import { useEffect, } from 'react';
// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// hooks
import useAuth from './hooks/useAuth';
// components
import Settings from './components/settings';
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import GoogleAnalytics from './components/GoogleAnalytics';
import NotistackProvider from './components/NotistackProvider';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import ThemeLocalization from './components/ThemeLocalization';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import LoadingScreen, { ProgressBarStyle } from './components/LoadingScreen';
// redux
import { RootState, useDispatch, useSelector } from './redux/store';
import { getDevices } from './redux/slice/device';
import { getRooms } from './redux/slice/room';
import { getScenarios } from './redux/slice/scenario';
// import { getLinks } from './redux/slice/link';

// ----------------------------------------------------------------------

export default function App() {
  const { isInitialized } = useAuth();
  const dispatch = useDispatch();
  const { currentPlace } = useSelector((state: RootState) => state.placeData);

  useEffect(() => {
    if (currentPlace == null)
      return
    const p_id = currentPlace.id
    dispatch(getDevices(p_id));
    dispatch(getRooms(p_id));
    dispatch(getScenarios(p_id));
  }, [currentPlace]);

  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <ThemeLocalization>
          <RtlLayout>
            <NotistackProvider>
              <GlobalStyles />
              <ProgressBarStyle />
              <BaseOptionChartStyle />
              <Settings />
              <ScrollToTop />
              <GoogleAnalytics />
              {isInitialized ? <Router /> : <LoadingScreen />}
            </NotistackProvider>
          </RtlLayout>
        </ThemeLocalization>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
